module.exports = __webpack_public_path__ + "static/img/45.b6ccdf77.png";